export default function getResource(label) {
    const resources = { review: 'évaluation, évaluations : évaluations' };
    return resources[label];
}
